// i18n.ts — Endpoints catalogue i18n + overrides + préférence locale.
import { req } from './_internals.js';

export const i18nApi = {
  // Catalogue (perm vocabulary.write côté admin tenant). Le navigateur honore
  // l'ETag posé par le backend automatiquement (cache HTTP par défaut sur
  // fetch GET) — pas d'option à passer.
  getI18n: (locale = 'fr') => req('GET', '/i18n?locale=' + encodeURIComponent(locale)),
  getI18nOverrides: (locale = 'fr') =>
    req('GET', '/i18n/overrides?locale=' + encodeURIComponent(locale)),
  putI18nOverrides: (locale: string, overrides: unknown) =>
    req('PUT', '/i18n/overrides', { locale, overrides }),
  deleteI18nOverride: (locale: string, key: string) =>
    req(
      'DELETE',
      '/i18n/overrides/' + encodeURIComponent(key) + '?locale=' + encodeURIComponent(locale),
    ),

  // Préférence locale du user courant (B.4). Auto-service, pas de perm.
  getI18nLocales: () => req('GET', '/i18n/locales'),
  setMyLocale: (locale: string) => req('PUT', '/i18n/me/locale', { locale }),
};
